export default "/images/234f8a1597cd8b3b9fb02c30132f7761.png";